if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}



/* CRUSH ACTIVE — Color-specific product gallery */
(() => {
  const getSelectedColor = () => {
    const checked = document.querySelector(
      'variant-radios input[name="Color"]:checked, ' +
      'variant-selects select[name="options[Color]"]'
    );

    if (checked) return checked.value.trim().toLowerCase();

    const selected = document.querySelector(
      'input[name="Color"]:checked'
    );

    return selected?.value.trim().toLowerCase() || null;
  };

  const updateGallery = () => {
    const color = getSelectedColor();
    if (!['bone', 'black'].includes(color)) return;

    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const slides = gallery.querySelectorAll(
        '[id^="Slider-Gallery-"] > li[data-crush-color]'
      );

      const thumbnails = gallery.querySelectorAll(
        '[id^="Slider-Thumbnails-"] > li[data-crush-color]'
      );

      slides.forEach((slide) => {
        slide.hidden = slide.dataset.crushColor !== color;
      });

      thumbnails.forEach((thumbnail) => {
        thumbnail.hidden = thumbnail.dataset.crushColor !== color;
      });

const slider = gallery.elements.viewer?.slider;

if (slider) {
  slider.resetPages();
}

      const firstVisible = [...slides].find(
        (slide) => !slide.hidden
      );

      if (firstVisible && gallery.setActiveMedia) {
        gallery.setActiveMedia(firstVisible.dataset.mediaId, false);
      }
    });
  };

  document.addEventListener('change', (event) => {
    if (
      event.target.matches(
        'variant-radios input, variant-selects select, ' +
        'input[name="Color"], select[name="options[Color]"]'
      )
    ) {
      setTimeout(updateGallery, 150);
    }
  });

  
const initializeCrushGallery = () => {
  updateGallery();

  requestAnimationFrame(() => {
    updateGallery();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCrushGallery);
} else {
  initializeCrushGallery();
}

})();



document.addEventListener('keydown', (event) => {
  if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
  if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

  const target = event.target;
  if (
    target instanceof Element &&
    (target.closest('input, textarea, select, [contenteditable="true"]') ||
      target.closest('[role="dialog"]'))
  ) return;

  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

const selectedColor = gallery.querySelector(
  '.product__media-list > li.is-active[data-crush-color]'
)?.dataset.crushColor;

const slides = Array.from(
  gallery.querySelectorAll('.product__media-list > li[data-media-id]')
).filter((slide) =>
  !slide.hidden &&
  (!selectedColor || slide.dataset.crushColor === selectedColor)
);

  if (slides.length < 2) return;

  let currentIndex = slides.findIndex((slide) =>
    slide.classList.contains('is-active')
  );

  if (currentIndex === -1) currentIndex = 0;

  const direction = event.key === 'ArrowRight' ? 1 : -1;
  const nextIndex = (currentIndex + direction + slides.length) % slides.length;
  const nextSlide = slides[nextIndex];

  if (!nextSlide || typeof gallery.setActiveMedia !== 'function') return;

  event.preventDefault();
  gallery.setActiveMedia(nextSlide.dataset.mediaId, false);
});
